var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "purchase-wrap" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "header" }, slot: "header" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("purchase::purchase-list::purchase-order-title")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: {
                inline: "",
                model: _vm.detailForm,
                rules: _vm.addRules,
                "label-position": "top",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("purchase::purchase-list::supplier"),
                            prop: "supplierId",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { flex: "1" },
                                  attrs: { popperAppendToBody: false },
                                  on: { change: _vm.handleSelectSupplier },
                                  model: {
                                    value: _vm.detailForm.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "supplierId",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.supplierId",
                                  },
                                },
                                _vm._l(_vm.supplierList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "stores::supplier::add",
                                    expression: "'stores::supplier::add'",
                                  },
                                ],
                                staticClass: "el-icon-plus add-btn",
                                on: {
                                  click: function ($event) {
                                    _vm.showAddSupplier = true
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t(
                              "purchase::purchase-list::plan_arrival_date"
                            ),
                            prop: "arrivalTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              appendToBody: false,
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t(
                                "purchase::purchase-list::date_select"
                              ),
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value: _vm.detailForm.arrivalTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "arrivalTime", $$v)
                              },
                              expression: "detailForm.arrivalTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t(
                              "purchase::purchase-list::purchase_shipping"
                            ),
                            prop: "freight",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "purchase::purchase-list::purchase_shipping"
                                ),
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.focusSelect($event)
                                },
                              },
                              model: {
                                value: _vm.detailForm.freight,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "freight", $$v)
                                },
                                expression: "detailForm.freight",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("RMB"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("purchase::purchase-list::remark"),
                            prop: "remark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              placeholder: _vm.$t(
                                "purchase::purchase-list::input_holder"
                              ),
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.detailForm.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "remark", $$v)
                              },
                              expression: "detailForm.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { margin: "10px 0 48px" } },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "header" }, slot: "header" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("purchase::purchase-list::purchase-goods-title")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !!_vm.detailForm.supplierId,
                  expression: "!!detailForm.supplierId",
                },
              ],
              staticClass: "row-style",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "mb10",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: {
                    click: function ($event) {
                      _vm.skuVisible = true
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("purchase::purchase-list::add_sku")) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-radio-group",
                {
                  staticClass: "mb10",
                  model: {
                    value: _vm.priceType,
                    callback: function ($$v) {
                      _vm.priceType = $$v
                    },
                    expression: "priceType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::price_input"))
                    ),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::total_input"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("z-table", {
            attrs: {
              columns: _vm.addColumns,
              data: _vm.skuList,
              customEmpty: true,
              "empty-text": _vm.$t("system::common::btn::no_data"),
              pagination: false,
              height: 450,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "sku-title" },
                      [
                        _c("ZImg", {
                          staticStyle: { width: "65px", height: "65px" },
                          attrs: { src: row.img },
                        }),
                        _c("div", { staticStyle: { "margin-left": "24px" } }, [
                          _c("div", { staticClass: "one-line" }, [
                            _vm._v(_vm._s(row.spuName)),
                          ]),
                          _c("p", [_vm._v("SKU：" + _vm._s(row.skuId))]),
                          row.optionValueNames
                            ? _c("p", [_vm._v(_vm._s(row.optionValueNames))])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "skuPriceHeader",
                fn: function () {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("purchase::purchase-list::single_price")
                        ) +
                        " "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top-start" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::price_equal")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("i", { staticClass: "el-icon-question" }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "skuPrice",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.priceType === 2
                      ? _c("span", [_vm._v(_vm._s(row.skuPrice))])
                      : _c("el-input-number", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            "controls-position": "right",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.focusSelect($event)
                            },
                          },
                          model: {
                            value: row.skuPrice,
                            callback: function ($$v) {
                              _vm.$set(row, "skuPrice", $$v)
                            },
                            expression: "row.skuPrice",
                          },
                        }),
                  ]
                },
              },
              {
                key: "quantity",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "150px" },
                      attrs: { min: 1, "controls-position": "right" },
                      on: {
                        focus: function ($event) {
                          return _vm.focusSelect($event)
                        },
                      },
                      model: {
                        value: row.skuBuyQuantity,
                        callback: function ($$v) {
                          _vm.$set(row, "skuBuyQuantity", $$v)
                        },
                        expression: "row.skuBuyQuantity",
                      },
                    }),
                  ]
                },
              },
              {
                key: "skuTotal",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.priceType === 1
                      ? _c("span", [_vm._v(_vm._s(row.skuTotal))])
                      : _c("el-input-number", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            "controls-position": "right",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.focusSelect($event)
                            },
                          },
                          model: {
                            value: row.skuTotal,
                            callback: function ($$v) {
                              _vm.$set(row, "skuTotal", $$v)
                            },
                            expression: "row.skuTotal",
                          },
                        }),
                  ]
                },
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#ff0022" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteSku(row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("p", { staticClass: "total-fee" }, [
            _vm._v(
              _vm._s(_vm.$t("purchase::purchase-list::total")) +
                "：" +
                _vm._s(_vm.totalFee)
            ),
          ]),
        ],
        1
      ),
      _c("edit-dialog", {
        ref: "edit",
        attrs: { isNew: true },
        on: { getListData: _vm.getSupplierList },
        model: {
          value: _vm.showAddSupplier,
          callback: function ($$v) {
            _vm.showAddSupplier = $$v
          },
          expression: "showAddSupplier",
        },
      }),
      _c("sku-dialog", {
        attrs: { skuList: _vm.skuList, supplierId: _vm.detailForm.supplierId },
        on: { addSku: _vm.addSku },
        model: {
          value: _vm.skuVisible,
          callback: function ($$v) {
            _vm.skuVisible = $$v
          },
          expression: "skuVisible",
        },
      }),
      _c(
        "footer-fixed",
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("purchase::purchase-list::cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "mlr16",
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.saveLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.handleSave(2)
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("purchase::purchase-list::save_audit")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "mlr16",
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.saveLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.handleSave(1)
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("purchase::purchase-list::save")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }